import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Table, Label } from 'semantic-ui-react';
import numeral from 'numeral';
import { commaFormatted } from '../../utils/helpers/formatting';

const AllTimeDataTable = ({ apiInfluencer, avgComments, isYouTubeCompliance }) => (
  <Table basic="very" fluid>
    <Table.Body>
      <Table.Row>
        <Table.Cell>videos</Table.Cell>
        <Table.Cell>
          { commaFormatted(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount) }
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>subscribers</Table.Cell>
        <Table.Cell>
          { commaFormatted(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount) }
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>views</Table.Cell>
        <Table.Cell>
          { commaFormatted(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount)}
        </Table.Cell>
      </Table.Row>
      { !isYouTubeCompliance &&
      <Table.Row>
        <Table.Cell>views per video</Table.Cell>
        <Table.Cell>
          { commaFormatted(apiInfluencer.aggregateYoutubeChannelStatistics.viewCount / apiInfluencer.aggregateYoutubeChannelStatistics.videoCount) }
        </Table.Cell>
      </Table.Row>
      }
      { !isYouTubeCompliance &&
      <Table.Row>
        <Table.Cell>comments per video</Table.Cell>
        <Table.Cell>{commaFormatted(avgComments)}</Table.Cell>
      </Table.Row>
      }
      { !isYouTubeCompliance &&
      <Table.Row>
        <Table.Cell>avg. daily viewing</Table.Cell>
        <Table.Cell>
          { commaFormatted(apiInfluencer.aggregateYoutubeChannelStatistics.averageDailyViews) }
        </Table.Cell>
      </Table.Row>
      }
      { !isYouTubeCompliance &&
      <Table.Row>
        <Table.Cell>avg. monthly viewing</Table.Cell>
        <Table.Cell>
          { commaFormatted(apiInfluencer.aggregateYoutubeChannelStatistics.averageMonthlyViews) }
        </Table.Cell>
      </Table.Row>
      }
    </Table.Body>
  </Table>
);

const LastThirtyDaysTable = ({ thirtyDayData, percentageChange }) => (
  <Table basic="very" fluid>
    <Table.Body>
      <Table.Row>
        <Table.Cell>30 day trend</Table.Cell>
        <Table.Cell>
          <Label
            basic
            color={(percentageChange > 0) ? 'green' : 'red'}
            content={numeral(percentageChange).format('+0.0%')}
          />
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>videos</Table.Cell>
        <Table.Cell>
          { commaFormatted(thirtyDayData.videoChange) }
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>subscribers</Table.Cell>
        <Table.Cell>
          <Label
            color={(percentageChange > 0) ? 'green' : 'red'}
            basic
            content={`${(percentageChange > 0) ? '+' : ''}${commaFormatted(thirtyDayData.subscriberChange)}`}
          />
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>views</Table.Cell>
        <Table.Cell>
          { commaFormatted(thirtyDayData.viewChange)}
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>avg. daily viewing</Table.Cell>
        <Table.Cell>
          { commaFormatted(thirtyDayData.viewChange / thirtyDayData.dayChange) }
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);


const YoutubeDataTabs = ({ percentageChange, apiInfluencer, avgComments, isYouTubeCompliance, thirtyDayData }) => {
  const panes = [
    { menuItem: { content: 'Last 30 days', key: 'last30', icon: 'calendar alternate outline' },
      render: () =>
        <LastThirtyDaysTable
          thirtyDayData={thirtyDayData}
          percentageChange={percentageChange}
        />,
    },
    { menuItem: { key: 'alltime', icon: 'history', content: 'All time' },
      render: () =>
        <AllTimeDataTable
          apiInfluencer={apiInfluencer}
          avgComments={avgComments}
          isYouTubeCompliance={isYouTubeCompliance}
        />,
    },
  ];

  return (
    <Tab panes={panes} />
  );
};


YoutubeDataTabs.propTypes = {
  percentageChange: PropTypes.number.isRequired,
  apiInfluencer: PropTypes.object.isRequired,
  avgComments: PropTypes.number.isRequired,
  isYouTubeCompliance: PropTypes.bool.isRequired,
  thirtyDayData: PropTypes.object.isRequired,
};

export default YoutubeDataTabs;



/** WEBPACK FOOTER **
 ** ./src/components/youtube-profile-data-large/youtube-data-tabs.js
 **/